export const BOOKING_URL = "https://calendly.com/katarina-bulic/30min";

export const NAV_LINKS = [
  { id: "how", label: "How it works" },
  { id: "licence", label: "Licence" },
  { id: "officer", label: "Your officer" },
  { id: "academy", label: "Academy" },
  { id: "faq", label: "FAQ" },
];
